import type { Permission } from "./permissions";
import { LICENSE_SETUP_TOUR_HREF } from "./license-setup-tour";
import { AUDIT_REVIEW_TOUR_HREF } from "./workflow-tours";

export type HelpGuide = {
  id: string;
  href: string;
  permission: Permission;
  tourHref?: string;
  steps: readonly { id: string; href?: string }[];
};

export const helpGuides: readonly HelpGuide[] = [
  {
    id: "issue", href: "/admin/licenses/new", permission: "createRecords", tourHref: LICENSE_SETUP_TOUR_HREF,
    steps: [{ id: "customer", href: "/admin/customers" }, { id: "product", href: "/admin/products" }, { id: "access" }, { id: "delivery" }, { id: "activation" }],
  },
  {
    id: "trial", href: "/admin/licenses/new", permission: "createRecords", tourHref: LICENSE_SETUP_TOUR_HREF,
    steps: [{ id: "setup" }, { id: "issue" }, { id: "delivery" }, { id: "paid" }],
  },
  {
    id: "devices", href: "/admin/licenses", permission: "read",
    steps: [{ id: "find" }, { id: "inspect" }, { id: "release" }, { id: "activate" }],
  },
  {
    id: "edit", href: "/admin/licenses", permission: "read",
    steps: [{ id: "find" }, { id: "configure" }, { id: "review" }],
  },
  {
    id: "audit", href: "/admin/audit", permission: "read", tourHref: AUDIT_REVIEW_TOUR_HREF,
    steps: [{ id: "find", href: "/admin/licenses" }, { id: "filter" }, { id: "export" }],
  },
];

export const productSetupGuide: HelpGuide = {
  id: "product", href: "/admin/products/new", permission: "createRecords",
  steps: [{ id: "check", href: "/admin/products" }, { id: "create" }, { id: "catalog" }],
};
